import 'normalize.css'
import './share/rootStyle.styl'
import Vue from 'vue'
import get_param from './tools/param'
import {error_event} from "./tools/mgtv/analysis";

if(window.apmInst && window.apmInst.captrueVueError){
  window.apmInst.captrueVueError(Vue)
}

// import 'encrypt-v01'


// window.onerror = function (msg, url, line, col, error) {
//   setTimeout(function () {
//     error_event(error, "", 'code_error');
//   }, 0);
//   return true;
// };


// window.addEventListener('unhandledrejection', function (e) {
//   e.preventDefault();
//   error_event(e.reason, "", 'code_error');
// }, false);


// function formatComponentName(vm) {
//   if (vm.$root === vm) return 'root';
//   var name = vm._isVue ? (vm.$options && vm.$options.name) || (vm.$options && vm.$options._componentTag) : vm.name;
//   return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');
// }


// Vue.config.errorHandler = function (err, vm, info) {
//   var componentName = formatComponentName(vm);
//   var propsData = vm.$options && vm.$options.propsData;
//   error_event(err,
//     {
//       vue: JSON.stringify({
//         componentName: componentName,
//         propsData: propsData ? JSON.stringify(propsData) : null,
//         info: info
//       })
//     }, 'code_error');
// };



import App from './App'
import {init_gact} from './tools/mgtv/gact'
import './EventBus/index'
import * as Cookie from 'tiny-cookie'
import {RETURN_URL} from './constant/CookieKeys'
import { towebp } from './tools/towebp';

//微信JS代扣跳转购买完成页面。
try{
  const return_url = Cookie.get(RETURN_URL);
  if(return_url){
    if(return_url){
      Cookie.remove(RETURN_URL);
      window.location.href = return_url;
    }
  }
}catch(e){
  error_event(e);
  console.error("main.js:jump to return_url error")
}


if(history.scrollRestoration === 'auto'){
  history.scrollRestoration = 'manual';
}

init_gact();

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})

// setTimeout(()=>{
//   const res = window.performance.getEntriesByType('resource')
//   res.forEach(item=>{
//     console.log(item.name)
//   })
// },5000)

// //
//  去除webp abtest
// setTimeout(()=>{

//   //首次访问时测试
//   if(window.apmInst && window.apmInst.isFirstVisit && window.apmInst.isFirstVisit()){

//     const src = towebp('https://vipcdn.mgtv.com/upload3/202009/webptest.jpg')
//     let mode = 'origin'
//     if(src.startsWith('mgwebp')){
//       mode = 'mgwebp'
//     }else if(src.endsWith('webp')){
//       mode = 'webp'
//     }

//     const startTime = new Date().getTime()
//     const img = new Image()
//     img.onload = function(){
//       if(window.apmInst){
//         const useTime = new Date().getTime() - startTime
//         window.apmInst.event('webpTest',{src,  mode, useTime})
//       }
//     }
//     img.onerror = ()=>{
//       if(window.apmInst){
//         const useTime = new Date().getTime() - startTime
//         window.apmInst.event('webpTest',{src,  mode, useTime, error: 1})
//       }
//     }
//     img.src = src
//   }

// },2000)
